var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVa(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.3 0H54v40H27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe000",
    d: "M.7 0h26.6v40H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m39.4 15.8.3.1h.6v.9l-.2.8-.2.5-.2.2-.7-.6.2-.3.1-.4v-.4l.1-.5zm-.9 2.5.7.5-.3.2-.5.1h-.3l-.7-.5V18l.1.1.3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M37.5 14v.8l-.1.4-.2.3-.2.4-.1.4v1.9l.6.6.3.1.4.2-.5-.4-.2-.5V17l.3-.6.2-.4.2-.5.1-.4v-.3l-.2-.5-.3-.3zq0 0 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M38.3 15.1V14a1 1 0 0 0-1-.7l-.7.1h-.2l.5.9.3-.1h.5l.3.2.2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce9d09",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m38.4 14.5-.2-.4-.3-.3h-.5l.2.3h-.4l-.1-.3-.3.1-.2-.2.3-.2-.1-.2h.3l.2.2h.3l.5.2.2.2v.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce9d09",
    d: "m36.2 13.5.5.8Zm.2-.1-.2.1-.2.2.5.8.2-.2.2-.1zm1 3.2.3-.6.3.1v-.3l-.2-.1.1-.4h-.2l-.1.2h-.4v.2l.2.2-.3.5zm2.3-.2h.3v.3h.2v.4h-.3v.3l-.2.2h-.3l.1-.3.1-.3h-.3v-.3h.4z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m36.2 13.5.5.8m-.3-1-.2.2-.2.2.5.8.2-.2.2-.1zm1 3.3.3-.6.3.1v-.3l-.2-.1.1-.4h-.2l-.1.2h-.4v.2l.2.2-.3.5zm2.3-.2h.3v.3h.2v.4h-.3v.3l-.2.2h-.3l.1-.3.1-.3h-.3v-.3h.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m42 15.8-.4.1H41v.9l.2.8q.1.4.3.5v.2l.8-.6-.2-.3V17l-.2-.4v-.8m.8 2.5-.6.5.2.2.5.1h.3q.5-.2.7-.5l.1-.3-.1-.3v.1l-.4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m43.9 14-.1.2v.6l.2.4.1.3.2.4.1.4.1.5v1l-.1.4-.6.6-.2.1-.4.2.5-.4.2-.5v-.5l-.2-.7-.2-.6-.2-.4-.2-.5v-.7l.1-.5.3-.3h.3q0 0 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M43 15.1V14a1 1 0 0 1 1-.7l.7.1h.2l-.5.9-.2-.1h-.6l-.3.2-.2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce9d09",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M43 14.5v-.4l.5-.3h.4l-.1.3h.3l.1-.3.4.1.1-.2-.3-.2.1-.2h-.3l-.1.2h-.4l-.5.2-.1.2-.1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce9d09",
    d: "m45 13.5-.4.8Zm-.1-.1.2.1.2.2-.5.8-.2-.2-.2-.1zm-1 3.2-.2-.6-.4.1v-.3l.2-.1-.1-.4h.2l.2.2h.3l.1.2-.3.2.3.5zm-2.3-.2h-.2v.3H41v.4h.3v.3l.2.2h.3l-.1-.3-.1-.3h.3v-.3h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m45 13.5-.4.8m.3-1 .2.2.2.2-.5.8-.2-.2-.2-.1zm-1 3.3-.2-.6-.4.1v-.3l.2-.1-.1-.4h.2l.2.2h.3l.1.2-.3.2.3.5zm-2.3-.2h-.2v.3H41v.4h.3v.3l.2.2h.3l-.1-.3-.1-.3h.3v-.3h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m39 11.8-.4.4.3.9.1.5-.4.4.8 1.2-.3.3v.3h.3l1 .2h.5l1-.1.3-.1v-.3l-.2-.6.8-.9-.3-.3v-.6l.2-.9-.4-.4-.3-1-.2-.4-.1-.2-.2-.2-.3-.1-.2-.1h-1l-.2.2-.3.2-.1.3-.1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce9d09",
    d: "m42.3 15-.2-.1-.3-.1-.7-.1h-1.6l-.2.2H39l-.1.1m3.5-.7h-.3v.3h.3zm0 0h.2Zm-3.7 0v.3h.3v-.3zm0 0h-.2Zm3 .1h-.2Zm-.9 0h-.1Zm1.9-.4-.1.1-.1.1-.1.1h-.3v.3h-.4V14h-.2v.3h-.7l.2-.1V14l-.1-.1h-.2v.3h-.1.1V14l-.1-.1h-.2v.2h.2-.2v-.3h-.3v.4h.2l-.2.2H40l-.3-.1V14h-.2v.4h-.4v-.3h-.4V14h-.3v.1l.1.1h.1v.2l.1.1h.1v.3l.2.1.1.4v.2l.5-.3h2.1q.3 0 .5.3v-.2l.1-.4.2-.1v-.3h.2v-.3h.1l.1-.2zm-2.4 0h.4v-.2h-.1l-.1-.1h-.2l-.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m42.3 15-.2-.1-.3-.1-.7-.1h-1.6l-.2.2H39l-.1.1m3.3 0-.1.4h0v.2l-.5-.3h-2.1q-.3 0-.5.3v-.2h0l-.1-.4m3.3 0 .2-.1v-.3h.2v-.2m-3.7.6-.2-.1v-.3h-.2v-.2m4-.1q0 0 0 0l.1-.2q0 0 0 0h-.2 0l-.1.1-.1.1h-.3v.3h0-.4v-.2q0 0 0 0V14h-.2v.1q0 0 0 0v.2h-.7q0 0 0 0l.2-.1V14l-.1-.1q0 0 0 0h-.1q0 0 0 0m-2.2.3h-.1m0 0q0 0 0 0h-.1l-.1-.2q0 0 0 0h.2zl.1.1h.3v.3h.4v-.2q0 0 0 0V14h.2v.1q0 0 0 0v.2h.7q0 0 0 0l-.1-.1-.1-.2v0l.1-.1h.2v.1q0 0 0 0m1.3.3h-.2m-.7 0h-.1m0 0q0 0 0 0h-.1q0 0 0 0m-.1-.3q0 0 0 0v-.2h-.1l-.1-.1h-.2l-.1.1v.2h.1q0 0 0 0h.2q0 0 0 0m0 0q0 0 0 0t0 0 0 0m0 0q0 0 0 0t0 0l-.1-.1h-.2q0 0 0 0m0 0q0 0 0 0m0 0q0 0 0 0t0 0m0 0h.2zq0 0 0 0m2 0h.3v.3h.3zm-3.7 0v.3h.3q0 0 0 0v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce9d09",
    d: "m42.6 13.3-.3-.1-.5-.2h-.6l-.2-.1h-.9l-.6.2H39l-.3.2m3.2-.7.1-.1v-.1h-.2zm-2.4 0v-.3h-.2v.2zm-.7.2-.2.3.1.2v.3l-.2.3.1.1.2-.1.3-.1.8-.3H41l.9.1.6.3.2.1-.1-.4v-.3l.1-.1V13l-.2-.3-.1.2h-.1l-.1-.1-.2-.2-.1-.1-.4.1h-.4l-.4-.1h-.5v.1h-.4l-.4-.1-.2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m42.6 13.3-.3-.1-.5-.2h-.6l-.2-.1h-.9l-.6.2H39l-.3.2m4 0-.1.3.2.3h0l-.1.1h0l-.2-.1-.6-.3-1-.1h-1l-1 .4-.2.1h0-.2 0l.2-.4v-.3m4 0V13l-.2-.3-.1.2h-.1l-.1-.1-.2-.2-.1-.1m-3.2.7-.1-.1.2-.3.2.2q0 0 0 0l.2-.1.2-.2v-.1l.4.1h.4q0 0 0 0l.5-.1h.4v.1h.4l.4-.1m0 0h-.1q0 0 0 0h-.1v.2q0 0 0 0m-2.4 0v-.3q0 0 0 0h-.2 0v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce9d09",
    d: "M42.7 12.7v-.2l-.2-.1m0 .4h.4v-.2h-.1v-.2l.1-.2v-.1h-.2l-.1.2v.1h-.2l-.1.1v.3zm-3.7-.4h-.1v.3m-.3-.7v.2l.1.2v.1l-.1.2v.1h.5l.1-.1v-.2l-.2-.1v-.1l-.1-.2zm2.1.2h.2m-.1.4-.2-.2.1-.2h-.1V12l.3-.2.1.1.1.1v.1l-.1.1v.4zm.3-.5.3.2v.1l-.1.3-.3-.1h-.6l-.1-.2q.1-.3.3-.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M42.7 12.7q0 0 0 0v-.2l-.2-.1m-3.7 0h-.1v.3m1.8-.5h.2m.2 0 .3.1v.1l-.1.3-.3-.1h-.6l-.1-.2q0 0 0 0 .1-.3.3-.3m2.1.7h.4q0 0 0 0v-.2h-.1v-.2l.1-.2v-.1q0 0 0 0t0 0h-.2l-.1.2v.1h-.2l-.1.1v.3zm-4.1-.8q0 0 0 0v.2l.1.2v.1q0 0 0 0l-.1.2q0 0 0 0v.1h.3q0 0 0 0h.2l.1-.1v-.2q0 0 0 0l-.2-.1v-.1l-.1-.2zm2.2.6-.2-.2q0 0 0 0l.1-.2h-.1V12q0 0 0 0l.3-.2.1.1.1.1v.1l-.1.1v.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce9d09",
    d: "M40.4 10.7h.2l-.1-.2v-.2h.2l.2.1v.1l-.1.1h-.1l.2.1m.8 0v.2Zm.5-.2h-.1Zm0 .2H42Zm-.2-.2v.2m-3 .6.4-.1h.3l.5-.1h1.6l.4.1h.2m-3.2-.5h.2Zm0 .3.4-.1h.3l.4-.1h1.6l.3.2m-2.7-.3h-.1v-.2m1 1.2h-.5l-.6.2-.5.2V12l.1-.2.1-.1v-.6l.3-.1-.1-.1v-.5l-.1-.1V10l.1.1.2.1v.2h.2v.2q0 .2 0 0h.3v-.2h.1v.3h.5v-.1q-.2 0-.2-.2l.1-.2h.2V10h.2l.2.1v.1l-.1.1h.2l.1.2-.1.2H41v.1h.5v-.3h.2v.1h-.1l.1.1h.1q.1.2.2 0h-.1v-.2h.2v-.2l.2-.1h.1v.6l-.2.2h.2v.3l.1.1v.3l.1.1.1.2v.1l-.5-.2q-.5-.2-1.1-.2zm.5-2.2h-.3m.3-.5-.1-.2q-.2 0-.1.2m.2.7h.2l-.2-.2.1-.1-.2-.3V9h.3v-.2h-.3v-.3h-.2l.2.3h-.4V9h.3l-.2.3v.1l.1.1-.1.2h.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M40.4 10.7h.2l-.1-.2q0 0 0 0v-.2h.2q0 0 0 0l.2.1v.1l-.1.1h-.1 0l.2.1m.8 0v.2m.5-.4h-.1m.1.2H42m0 0v-.2m-3 .8.4-.1h.3l.5-.1h1.6l.4.1h.2m-3.3-.5h.2m-.1.3.3-.1h.3l.4-.1h1.6l.3.2m-2.7-.3h-.1v-.2m1.5-1h-.3m.3-.5-.1-.2q-.2 0-.1.2m0 0h-.3v-.2h.4l-.2-.3h.2q0 0 0 0v.3h.3q0 0 0 0V9zl.2.3v.4q0 0 0 0t-.1 0h-.4q0 0 0 0l.1-.2-.1-.1q0 0 0 0 0-.2.3-.3zm-.3 2.7h-.5l-.6.2-.5.2V12l.1-.2.1-.1v-.6l.3-.1-.1-.1q0 0 0 0v-.2q0 0 0 0v-.1q0 0 0 0v-.2l-.1-.1V10l.1.1.2.1v.2h.2v.2q0 0 0 0 0 .2 0 0h.2q0 0 0 0h.1v-.1h0v-.1h.1v.1q0 0 0 0h0v.2h.5q0 0 0 0v-.1q-.2 0-.2-.2l.1-.2h.2v-.1q0 0 0 0V10h.2q0 0 0 0l.2.1v.1l-.1.1h.2l.1.2-.1.2h0v.1h.5v-.1h0q0 0 0 0v-.1q0 0 0 0v-.1h.2v.1q0 0 0 0h-.1q0 0 0 0l.1.1h.1q.1.2.2 0h-.1v-.2h.2v-.2l.2-.1h.1q0 0 0 0v.3q0 0 0 0v.3q0 0 0 0l-.2.2h.2v.3l.1.1v.3l.1.1.1.2v.1l-.5-.2q-.5-.2-1.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m42.2 15.3-.2-.1-.3-.1h-2.1l-.5.2m3.3-3.6-.3-.1h-.3l-.3-.1-.8-.1h-.5l-1 .2-.3.1m-.2 2 .4-.2.5-.1.5-.1h1.6l.5.2.4.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m35.4 14.5 1.7 1.4-.1.2-.2.7-1.9-1.7q.1-.6.5-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m35.2 15.3-.4.5.3.2-.4.4-.2-.3-.5.5v.5l1 .7.3-.2V17l.2.1.3-.1v.4l-.2-.1-.2.3v.5l.6.6.9-.8v-.2l-.1-.2v-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M34.8 15.8v.4l.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M36 18.2v.6m-.3-2.2v.5m-.2-.3v.4m-.2-.6v.5m-.3.2v.5m.4-.1.7.6.7-.7m-2.7-1 .9.7.3-.2-.3-.2.3-.3.2.2.2-.2.3.3-.2.2.2.2-.2.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m41.3 19.7.8.7.2.5-1-.1-.6-.6-.6-.5-2.6-2.3V17l.2-.5 3 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M42 19.8c.4.6 1.2 1.2 1.4 1.4q.4.4 0 1-.5.3-1-.1-.3-.4-1.5-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "m41.7 20.8-.5-.3Zm.1-.9v.4l.3.3H42l-.3.2.2.2.1.1.3.1h.5-.2q-.2.2 0 .3h.4l.2.4h-.3v-.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m41.7 20.8-.5-.3m.6-.6v.4l.3.3H42l-.3.2.2.2.1.1.3.1h.5-.2q-.2.2 0 .3h.4l.2.4h-.3v-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M45.4 25.8a2 2 0 1 0 0-4.2 2 2 0 0 0 0 4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M44.6 23.8a.6.6 0 1 0 .7.6h.2a.6.6 0 1 0 .6-.6v-.2a.6.6 0 1 0-.6-.6h-.2a.6.6 0 1 0-.7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M45.4 23.4a.2.2 0 1 0 0-.5.2.2 0 0 0 0 .5Zm.6.6a.2.2 0 1 0 0-.6.2.2 0 0 0 0 .5Zm-.6.4a.2.2 0 1 0 0-.5.2.2 0 0 0 0 .5Zm-.6-.4a.2.2 0 1 0 0-.6.2.2 0 0 0 0 .5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m45.4 25-.4.3h.7zM44 23.6l-.3-.4v.7zm2.6 0q.2 0 .3-.3v.7q0-.3-.3-.4Zm-1.3-1.3q0-.2-.3-.3h.7q-.3 0-.4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce9d09",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M35.5 14.5v-.2l-.2-.1h-.6l-.1.4v.4h.3q0-.4.6-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce9d09",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m35 14.2-.7-.3.3.7.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce9d09",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M34.2 14.1a.3.3 0 1 0 0-.5.3.3 0 0 0 0 .5Zm1.8.9.2 1.3.5.4-.3-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce9d09",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m36.7 15.6-1.3-.1.4.4H37zm1.7 1.5-.6.6-.2-.1a1 1 0 0 1 .5-.8q.3 0 .3.3Zm.5.4a1 1 0 0 0-.7.6H38a1 1 0 0 1 .6-.9q.2 0 .3.3Zm5 4.2h-.3l-.2.4-.4.2v.4h.5l.6-.6v-.4zm3.1.6a.3.3 0 1 0 0-.6.3.3 0 0 0 0 .6Zm0 3.3a.3.3 0 1 0 0-.6.3.3 0 0 0 0 .6Zm-3 .1a.3.3 0 1 0 0-.5.3.3 0 0 0 0 .5Zm1.9-11.2-1.6 1.4v.2q.3.4.2.7l2-1.7q-.2-.6-.6-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce9d09",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m46.1 15.3.4.5-.2.2.3.4.3-.3.4.5v.5l-1 .7-.3-.2V17l-.2.1-.2-.1v.4l.2-.1.2.3v.5l-.7.6-.9-.8.1-.2v-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce9d09",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M46.5 15.8v.4l-.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M45.3 18.2v.6m.3-2.2v.5m.2-.3v.4m.2-.6v.5m.4.2v.5m-.4-.1-.7.6-.8-.7m2.8-1-1 .7-.2-.2.2-.2-.3-.3-.2.2-.2-.2-.3.3.3.2-.3.2.2.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce9d09",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m40 19.7-.8.7-.2.5 1-.1.6-.6.6-.5 2.7-2.3-.1-.3-.2-.5-3 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce9d09",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M39.3 19.8q-.8 1-1.4 1.4-.4.4 0 1 .5.3 1-.1l1.5-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce9d09",
    d: "m39.6 20.8.6-.3Zm-.1-.9v.4l-.3.3h.2l.2.2-.1.2-.2.1-.3.1h-.4.1q.3.2.1.3t-.2 0h-.3l-.2.4h.4v-.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m39.6 20.8.6-.3m-.7-.6v.4l-.3.3h.2l.2.2-.1.2-.2.1-.3.1h-.4.1q.3.2.1.3t-.2 0h-.3l-.2.4h.4v-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce9d09",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M36 25.8a2 2 0 1 1 0-4.2 2 2 0 0 1 0 4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M36.7 23.8a.6.6 0 1 1-.6.6h-.3a.6.6 0 1 1-.6-.6v-.2a.6.6 0 1 1 .6-.6h.3a.6.6 0 1 1 .6.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce9d09",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M36 23.4a.2.2 0 1 1 0-.5.2.2 0 0 1 0 .5Zm-.6.6a.2.2 0 1 1 0-.6.2.2 0 0 1 0 .5Zm.6.4a.2.2 0 1 1 0-.5.2.2 0 0 1 0 .5Zm.5-.4a.2.2 0 1 1 0-.6.2.2 0 0 1 0 .5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m36 25 .3.3h-.7q.3 0 .4-.4Zm1.2-1.3.4-.4v.7q-.1-.2-.4-.3Zm-2.5 0-.4-.3v.7q0-.3.4-.4Zm1.2-1.3q.1-.2.4-.3h-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M45.9 14.5v-.3h.8v.4h.1v.4h-.4q0-.4-.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m46.4 14.2.6-.3-.3.7-.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M47.1 14.1a.3.3 0 1 1 0-.5.3.3 0 0 1 0 .5Zm-1.7.9-.3 1.3-.5.4.3-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m44.6 15.6 1.4-.1-.5.4h-1.2zM43 17l.6.6.3-.1a1 1 0 0 0-.6-.8q-.3 0-.3.3Zm-.4.4.6.6h.2a1 1 0 0 0-.6-.9q-.2 0-.2.3Zm-5 4.2h.2l.2.4.4.2v.4h-.5l-.5-.6v-.4zm-3.3.7a.3.3 0 1 1 0-.6.3.3 0 0 1 0 .6Zm-.1 3.3a.3.3 0 1 1 0-.6.3.3 0 0 1 0 .6Zm3.2.1a.3.3 0 1 1 0-.5.3.3 0 0 1 0 .5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fa0204",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m40.8 18.8-.2.1-.2-.1.2-.1zm.2.2q0 .2-.3.2t-.2-.2h.4Zm0 .3h-.3q-.2 0-.1-.1h.2zm0 .3h-.3q-.2 0-.1-.1 0-.2.2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fa0204",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M41 19.8q0 .2-.2 0h-.2q0-.3.2-.1zm.7-.3v-.3.1zm-.2.1v-.1l.1-.2v.3Zm-.2.2v-.2l.1-.1v.3Zm-.2.2v-.2l.1-.1v.2zm0 .2h-.2l-.1-.2h.2zm-1.4-.8h.2v.2h-.1zm.4.1q.1 0 0 .2l-.2.1v-.2h.2zm.3.2v.2h-.3v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fa0204",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M40.6 19.9q.2 0 0 .1l-.2.1v-.2zm.1.1.1.2-.2.2v-.2zm.3.2v.3h-.3v-.2zm-1.5-.6.2.2-.2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fa0204",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M39.8 19.8v.2l-.2.2v-.3zm.2.2v.2l-.2.2V20l.2-.2Zm.1.1.2.2-.1.3-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fa0204",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m40.3 20.3.2.1-.1.2q-.2 0-.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fa0204",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m40.5 20.4.2.2-.1.2-.2-.2zm1.3-.4h-.2v-.2h.2zm-.1.2h-.2V20h.2zm-.2.2h-.2V20h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fa0204",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M41.4 20.5h-.3q0-.2.2-.2zm-.3 0v.2l-.2.1v-.3zm-.3.1v.2l-.2.1v-.2zm-.6.4v.3h.3v-.2h-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fa0204",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M40.1 21.2v.3h.3v-.2H40Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fa0204",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M40 21.4v.3l.2.1v-.2l-.1-.2Zm-.1.3v.2l.1.2v-.3zm-.1.3-.1.2.1.2.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fa0204",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M39.6 22.2v.4q.3 0 .2-.2zm-.1.3q-.2 0-.2.2l.2.2.1-.2zm-.2.3-.1.2.1.2.1-.2zm-.2.2-.1.3.1.2.1-.3zm-.2.3-.1.2.1.2.1-.2zm-.2.2-.1.2q0 .3.1.2l.1-.2zm-.2.2-.2.2.2.2.1-.2zm-.2.2-.2.2q0 .2.2.2V24Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fa0204",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M38 24v.4l.1-.2zm5.2.2.2.2v-.5q-.3 0-.2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fa0204",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m43.2 23.9-.2.1v.3l.2-.2zm-.2-.2q-.2 0-.2.2l.1.2.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fa0204",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m42.7 23.4-.1.2v.3q.3-.1.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fa0204",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m42.5 23.2-.1.2v.2q.3 0 .2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fa0204",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m42.3 23-.1.2v.2q.3 0 .2-.2zm-.2-.3-.1.2.1.2.2-.2zm-.1-.3-.2.2.1.3.2-.3zm-.2-.2-.1.2v.2l.2-.2zm-.1-.4-.2.2.1.3.2-.2zm-.2-.2-.2.2.2.2.1-.2zm-.1-.4-.2.2.1.2q.2 0 .2-.2zm-.4-.3.2.4.2-.2zm-.3 4.9v.2h.3v-.2zm.3-.1v.3h.3v-.2zm.3 0v.2h.3v-.2zm.3 0v.2h.3v-.2zm.3-.1.1.2h.3l-.2-.2zm.3-.1.1.2h.3l-.2-.2zm.3-.1.1.2h.3l-.2-.2zm.3-.1.1.2h.3l-.2-.2zm.2-.1.2.2h.3l-.2-.2zm.4-.1.1.2h.3l-.2-.2zm.3-.1.1.2h.3l-.2-.3zm.3-.1.2.2h.2l-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fa0204",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m44 24.6.2.2h.3l-.2-.2zm0 0h.2l-.2-.3zm-5.9.6v.3h.3v-.2zm.3.1v.3l.3.1v-.3zm.3.1v.2l.3.2v-.3zm.3.1v.2l.3.1v-.2zm.3 0v.2l.3.2v-.3zm.3.1v.2l.2.1v-.2q0-.2-.2-.1Zm.4 0q-.2 0-.1.3l.2.1v-.3h-.2Zm.2.1v.2l.2.2v-.3zm.3 0v.3l.2.1v-.3h-.2Zm-3.2-1.4-.2.1v.3l.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fa0204",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m37.2 24.6-.2.1v.3l.2-.2zm.1.2-.2.2v.2l.3-.2zm.2.1-.2.2v.2q.3 0 .3-.2V25Zm.2.1-.1.2.2.2V25l-.1-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fa0204",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M38 25q-.2 0-.1.3l.1.2.1-.3-.2-.2Zm2.4-4.2v.3h.2v-.2h-.2Zm-.1.3v.3h.3v-.2h-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fa0204",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M40.3 21.4v.3h.3v-.2h-.3Zm0 .4v.2h.3v-.2zm0 .3v.2q.2.2.3.1v-.2zm0 .3v.3h.2v-.2h-.2Zm0 .4v.2h.3v-.2zm0 .2v.3h.2v-.2zm0 .3v.2q.2.2.3.1v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fa0204",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M40.3 23.6v.3h.3v-.2h-.3Zm0 .4v.2h.3V24zm0 .3v.2h.3v-.2zm0 .3v.2l.3.1v-.3zm0 .3v.2q0 .2.3.1V25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fa0204",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M40.3 25.2v.3h.3v-.2h-.3Zm0 .3v.3h.2v-.2h-.2Zm0 .4v.2l.2.1V26zm-.1.4v.2h.3v-.2zm0 .3v.2l.3.1v-.2q0-.2-.3-.1Zm0 .4v.2h.3V27zm0 .3v.2h.3v-.2zm.8-6.4v.2h-.3l.1-.2zm0 .2v.2h-.2v-.2zm0 .3v.2h-.2v-.2zm0 .3v.2h-.2v-.2zm0 .3v.2h-.3l.1-.2zm0 .2v.3h-.2v-.2h.3Zm0 .3v.2h-.3l.1-.2zm0 .3v.2h-.3l.1-.2zm0 .3v.2q0 .2-.3.1l.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fa0204",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M41 23.4v.3h-.2v-.2h.2Zm0 .3v.3h-.2v-.2h.2Zm0 .3v.3q0 .2-.3.1l.1-.2.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fa0204",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M41 24.4v.3h-.2v-.2h.2Zm0 .3v.3h-.3l.1-.2h.2Zm0 .3v.3h-.2v-.2h.2Zm0 .4v.2l-.2.1v-.2zm0 .3v.3h-.3v-.2h.3Zm0 .3v.3h-.2v-.2h.2Zm0 .3v.3h-.2v-.2h.2Zm0 .4v.2q0 .2-.3.1l.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fa0204",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M41 27v.3h-.3l.1-.2h.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fa0204",
    d: "M40.5 29.6h.8L41 29"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M40.5 29.6h.8L41 29"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce9d09",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m41.1 28.4-.5-.1s0-.6.3-.5.2.6.2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce9d09",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M40.9 27.8a.2.2 0 1 0 0-.4.2.2 0 0 0 0 .4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fa0204",
    d: "M41 28.7q.3.4.2.8Zm.3.9q-.4-.2-.8 0s-.3-1.4.4-1.3.4 1.3.4 1.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M41 28.7q.3.4.2.8m0 0h-.7s-.3-1.3.4-1.2c.6 0 .4 1.3.4 1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fa0204",
    d: "M40 29.9h.8l-.6-.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M40 29.9h.8l-.6-.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce9d09",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M40.4 28a.2.2 0 1 0 0-.4.2.2 0 0 0 0 .4Zm.3.5H40s0-.5.3-.5.3.5.3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fa0204",
    d: "M40.4 29.8V29Zm-.2 0q-.2-.3 0-.8Zm.6 0H40c-.1 0-.3-1.4.4-1.4s.5 1.5.4 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M40.4 29.8V29m-.2.8q-.2-.3 0-.8m.6.9c0-.1-.6-.2-.8 0-.1 0-.3-1.5.4-1.5s.5 1.5.4 1.5Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVa);
export default __webpack_public_path__ + "static/media/va.b08659cf2ac2773a1ae1e9ad504b82c4.svg";
export { ForwardRef as ReactComponent };